import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UnknowErrorHandleRequest } from '../models/unknow-error-handle-request';
import { UnknowErrorlog } from 'server/entity/unknow-errorlog';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(
    private http: HttpClient,
    private httpBackend: HttpBackend,
  ) {
    this.http = new HttpClient(this.httpBackend);
  }

  storeUnknowError(req: UnknowErrorHandleRequest): Observable<any> {
    const url = `${environment.logisticsApiUrl}/logistics/errorHandler/storeErrorLog`;
    return this.http.put(url, req);
  }

  storeErrorLog(req: any): Observable<void>{
    // const url = '/api/unknowErrorlog';
    const url = `${environment.logisticsApiUrl}/Common/saveUnknowErrorLog`;
    return this.http.post<void>(url, req);
  }
}
